<template>
  <v-card>
    <v-card-title>
      <span class="headline" data-test="form-title">{{ formTitle }}</span>
    </v-card-title>

    <v-card-text>
      <v-form>
        <v-container>
          <v-row >
            <v-col cols="10">
              <v-text-field 
                ref="name-input"
                v-model="document.title" 
                label="Nom" 
                required
                :error-messages="titleErrors"
                @keyup.enter="save"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-switch v-model="document.isVisible" :label="$t('Documents.Form.visibility')"></v-switch>
            </v-col>
            <v-col cols="12" v-if="document.id">
              <v-icon small class="mr-2">attachment</v-icon> <a @click="download">{{document.fileName}}</a>
            </v-col>
            <v-col v-else>
              <input id="file" type="file" @change="handleFile" ref="file">
              <p v-if="!$v.document.file.required && $v.document.title.$dirty" class="error--text">{{$t('Documents.Form.fileRequired')}}</p>
            </v-col>
            <v-col cols="12">
              <v-textarea 
                ref="description-textarea"
                v-model="document.description" 
                label="Description" 
                @keyup.enter="save"
              ></v-textarea>
            </v-col>
            <v-col cols="6">
              <MallSelector v-model="document.mall" outline :label="$t('Documents.Form.mall')" :errorMessages="mallErrors"/>
            </v-col>
            <v-col cols="6">
              <CategorySelector v-model="document.category" outline :label="$t('Documents.Form.category')"/>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn ref="cancel-btn" color="primary" text @click="cancel">{{$t('Global.Action.cancel')}}</v-btn>
      <v-btn ref="save-btn" color="primary" text @click="save">{{$t('Global.Action.save')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import CategorySelector from '@/components/Utils/CategorySelector'
import MallSelector from '@/components/Utils/MallSelector'
export default {
  name: 'DocumentEditor',
  components: { CategorySelector, MallSelector },
  props: {
    defaultDocument: {type: Object, required: false},
    defaultFormTitle: {type: String, required: false}
  },
  data: () => ({
    document: null,
    fileListener: null,
    default: {
      title: '',
      file: null,
      description: '',
      isVisible: false,
      groups: [],
      mall: null,
      category: null
    }
  }),
  computed: {
    formTitle () {
      return this.defaultFormTitle || (this.document.id ? 'Modification' : 'Création')
    },
    titleErrors () {
      const errors = []
      if (!this.$v.document.title.$dirty) return errors
      !this.$v.document.title.required && errors.push(this.$t('Global.Common.required'))
      return errors
    },
    mallErrors () {
      const errors = []
      if (!this.$v.document.mall.$dirty) return errors
      !this.$v.document.mall.required && errors.push(this.$t('Global.Common.required'))
      return errors
    }
  },
  watch: {
    defaultDocument () {
      this.resetForm()
    }
  },
  validations: {
    document: {
      title: { required },
      file: { required: requiredIf((document) => !document.id) },
      mall: { required }
    }
  },
  methods: {
    handleFile () {
      this.document.file = this.$refs.file.files[0]
    },
    init () {
      this.document = this.defaultDocument ? {...this.defaultDocument} : {...this.default}
    },
    save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('save', this.document)
      } else {
        this.$emit('invalid-form')
      }
    },
    cancel () {
      this.$emit('cancel')
      this.resetForm()
    },
    resetForm () {
      this.init()
      if (this.$refs.file) this.$refs.file.value = null
      this.$v.$reset()
    },
    download () {
      window.open(process.env.VUE_APP_SERVER_ADDRESS + '/files/documents/' + this.document.fileName)
    }
  },
  created () {
    this.init()
  }
}
</script>